import { DatePipe } from '@angular/common';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import * as lodash from 'lodash';
import { DateTime } from 'luxon';

export function cloneAndClearId(formGroup: FormGroup): FormGroup {
  const clonedValues = lodash.cloneDeep(formGroup.value);

  const clearIdValues = (obj: any) => {
    if (obj && typeof obj === 'object') {
      for (const key in obj) {
        if (key === 'id' && ('adSetName' in obj || 'adSetId' in obj || 'categoryType' in obj)) {
          obj[key] = null;
        } else if (Array.isArray(obj[key])) {
          obj[key].forEach(clearIdValues);
        } else if (typeof obj[key] === 'object') {
          clearIdValues(obj[key]);
        }
      }
    }
  };
  clearIdValues(clonedValues);

  const clonedFormGroup = cloneFormGroup(formGroup);
  clonedFormGroup.patchValue(clonedValues);

  return clonedFormGroup;
}

function cloneAbstractControl(control: AbstractControl): AbstractControl {
  if (control instanceof FormControl) {
    return new FormControl(control.value, control.validator, control.asyncValidator);
  } else if (control instanceof FormGroup) {
    const groupCopy = new FormGroup({});
    Object.keys(control.controls).forEach(key => {
      groupCopy.addControl(key, cloneAbstractControl(control.controls[key]));
    });
    return groupCopy;
  } else if (control instanceof FormArray) {
    const arrayCopy: any = new FormArray([]);
    control.controls.forEach(ctrl => {
      arrayCopy.push(cloneAbstractControl(ctrl));
    });
    return arrayCopy;
  } else {
    throw new Error('Unsupported control type');
  }
}

function cloneFormGroup(formGroup: FormGroup): FormGroup {
  return cloneAbstractControl(formGroup) as FormGroup;
}

export function currentDateByTimeZone(timeZoneName: string, minuteDeviation = 0) {
  const userNow = DateTime.now().setZone(timeZoneName);
  const adjustedDate = DateTime.fromObject(
    {
      year: userNow.year,
      month: userNow.month,
      day: userNow.day,
      hour: userNow.hour,
      minute: userNow.minute + minuteDeviation,
      second: 0
    },
    { zone: 'local' } // để tạo JS Date theo local nhưng với giờ giống userNow
  );
  return new Date(adjustedDate.toJSDate());
}

export function convertDateByTimeZone(inputTimeISO: string, timeZoneName: string) {
  // Parse input ISO string với múi giờ gốc có sẵn trong chuỗi (ví dụ -0600)
  const userNow = DateTime.fromISO(inputTimeISO).setZone(timeZoneName);

  // Tạo đối tượng Date theo local time, nhưng với giá trị giờ giống userNow
  const adjustedDate = DateTime.fromObject(
    {
      year: userNow.year,
      month: userNow.month,
      day: userNow.day,
      hour: userNow.hour,
      minute: userNow.minute,
      second: userNow.second
    },
    { zone: 'local' }
  );

  return new Date(adjustedDate.toJSDate());
}

export function convertTimezoneToIsoString(date: Date, timeZone: string, datePipe: DatePipe): string {
  return datePipe
    .transform(date, "yyyy-MM-dd'T'HH:mm:ssZZZZZ")
    ?.replace(/([+-]\d{2}:\d{2}|Z)$/, formatTimezoneOffset(parseInt(timeZone))) as string;
}

function formatTimezoneOffset(offset: number): string {
  // Ensure the offset is an integer
  const hours = Math.abs(offset).toString().padStart(2, '0');
  // Determine the sign
  const sign = offset >= 0 ? '+' : '-';
  // Format the offset into -06:00 style
  return `${sign}${hours}:00`;
}

export function onCheckDurationTimeCP(startDate: string, endDate: string) {
  if (!startDate || !endDate) return 30; // Ensure dates are valid
  const start = new Date(startDate);
  const end = new Date(endDate);
  // Calculate the difference in time (milliseconds) and convert to days
  const diffInTime = end.getTime() - start.getTime();
  const diffInDays = Math.ceil(diffInTime / (1000 * 60 * 60 * 24));

  switch (diffInDays) {
    case 30:
      return diffInDays;
      break;
    case 15:
      return diffInDays;
      break;
    case 14:
      return 15;
      break;
    case 7:
      return diffInDays;
      break;
    case 6:
      return 7;
      break;
    case 3:
      return diffInDays;
      break;
    case 2:
      return 3;
      break;
    default:
      return 0;
      break;
  }
}
